// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3B74s","footer":"ModalInfo_footer__1s-hL"};